"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Put } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type { BomResponse, SaveBomRequest } from "@stocks/shared";

/** BOM 저장 — 저장할 때마다 새 버전이 생기고 이전 버전은 서버에 보존된다 */
export const useSaveBom = (productId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (values: SaveBomRequest) =>
      Put<BomResponse, SaveBomRequest>(`/v1/products/${productId}/bom`, values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: orderKeys.bom(productId) });
      qc.invalidateQueries({ queryKey: orderKeys.product(productId) });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "BOM 저장에 실패했습니다."),
  });
};
